const companyId = 'repfrq2uozf9ok0e'

// Temporary workaround to get the manifest URL
export const getIframeVideoManifestSrc = (
    iframeVideoSrcOrVideoId: string
): string => {
    if (!iframeVideoSrcOrVideoId) return iframeVideoSrcOrVideoId

    let videoId: string
    if (iframeVideoSrcOrVideoId.startsWith('https://')) {
        const iframeUrl = new URL(iframeVideoSrcOrVideoId)

        videoId = iframeUrl.pathname.split('/').pop() ?? ''
    } else {
        videoId = iframeVideoSrcOrVideoId
    }

    const manifestUrl = new URL(
        `${videoId}/manifest/video.m3u8`,
        `https://customer-${companyId}.cloudflarestream.com`
    )

    return manifestUrl.toString()
}
